import React from 'react';
import Inline from './inline';
export default function Paragraph(_a) {
    var children = _a.children;
    return (React.createElement("p", null,
        React.createElement(Inline, null, children)));
}
//# sourceMappingURL=paragraph.js.map